export function css($el: HTMLElement, style: Partial<CSSStyleDeclaration>) {
	Object.assign($el.style, style);
}
